function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

export var netherlands = {
  name: 'Netherlands',
  codes: ['NL', 'NLD', '528'],
  calcFn: function calcFn(input) {
    var vat = input.replace(/[\ \-\_]/g, '').toUpperCase();
    var _netherlands$rules = netherlands.rules,
        additional = _netherlands$rules.additional,
        multipliers = _netherlands$rules.multipliers;
    if (!additional) return false;
    var match = vat.match(additional[0]);
    if (!match || !match[1]) return false;
    var numb = match[1];
    var characterValues = "NL".concat(vat).split('').map(getCharValue);
    var total = 0; // Extract the next digit and multiply by the counter.

    for (var i = 0; i < 8; i++) {
      total += Number(numb.charAt(i)) * multipliers.common[i];
    } // Establish check digits by getting modulus 11.


    total = total % 11;

    if (total > 9) {
      total = 0;
    } // Compare it with the last character of the VAT number. If it's the same, then it's valid.


    var expect = Number(numb.slice(8, 9)); // is either 11 proof or 97 mod proof.

    return total === expect || isNinetySevenMod(characterValues.join(''));
  },
  rules: {
    multipliers: {
      common: [9, 8, 7, 6, 5, 4, 3, 2]
    },
    regex: [/^(NL)(\d{9}B\d{2})$/],
    additional: [/^(\d{9})B\d{2}$/]
  }
};

function getCharValue(char) {
  // if one of these set values
  if (char === '+') return 36;
  if (char === '*') return 37; // if A...Z return code VAL -55

  var code = char.charCodeAt(0) - 55;
  if (code > 9 && code < 91) return code;
  return parseInt(char, 10);
}

function isNinetySevenMod(value) {
  var remainder = mod(value, 97);
  return remainder === 1;
} // custom module function, to check module on values above Number limit


function mod(value, divisor) {
  // Initialize result
  var res = 0;

  var _iterator = _createForOfIteratorHelper(value.split('')),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var char = _step.value;
      res = (res * 10 + +char) % divisor;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return res;
}